'use client';

// APPEL FINAL — volontairement CLAIR et éditorial.
//
// La section Trust juste avant est un grand panneau encre ; refaire ici un second panneau
// sombre aurait sonné comme un doublon. On termine donc sur le fond crème, en registre
// « dernière page d'un carnet » : un trait, une phrase serif très grande, deux portes de
// sortie. Le calme après la démonstration.

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

import { useT } from '@/hooks/useT';
import { useReveal } from '@/hooks/useReveal';
import { fontStyle } from '@/theme/typography';

export function CtaBand() {
  const { t } = useT('landing');
  const ref = useReveal<HTMLDivElement>({ threshold: 0.15 });

  return (
    <section className="relative overflow-hidden px-5 pb-24 pt-10 sm:px-8 lg:pb-32">
      <div
        aria-hidden
        className="rmbr-pulse-glow pointer-events-none absolute left-1/2 top-0 -z-10 size-[36rem] -translate-x-1/2 rounded-full blur-3xl"
        style={{
          background:
            'radial-gradient(circle, var(--rmbr-brand-muted), transparent 68%)',
        }}
      />

      <div
        ref={ref}
        className="mx-auto flex w-full max-w-3xl flex-col items-center gap-7 text-center"
      >
        <span aria-hidden className="rmbr-rule h-px w-24 bg-brand" />

        <h2
          className="rmbr-rise text-balance text-text-primary"
          style={{
            ['--rmbr-stagger' as string]: '80ms',
            fontFamily: 'var(--font-serif)',
            fontSize: 'clamp(2.25rem, 5.2vw, 4rem)',
            lineHeight: 1.02,
            letterSpacing: '-0.035em',
            fontWeight: 600,
          }}
        >
          {t('cta.heading')}
        </h2>

        <p
          className="rmbr-rise max-w-lg text-pretty text-text-secondary"
          style={{
            ...fontStyle('bodyLg'),
            ['--rmbr-stagger' as string]: '160ms',
          }}
        >
          {t('cta.body')}
        </p>

        <div
          className="rmbr-rise mt-1 flex flex-wrap items-center justify-center gap-3"
          style={{ ['--rmbr-stagger' as string]: '240ms' }}
        >
          <Link
            href="/sign-up"
            style={fontStyle('button')}
            className="rmbr-lift group inline-flex h-12 items-center gap-2 rounded-full bg-action px-7 text-action-on shadow-[var(--rmbr-glow-action)] hover:bg-action-hover"
          >
            {t('cta.button')}
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            href="/tarifs"
            style={fontStyle('button')}
            className="rmbr-lift inline-flex h-12 items-center rounded-full border border-border bg-surface/60 px-7 text-text-primary backdrop-blur hover:bg-fill-subtle"
          >
            {t('cta.pricing')}
          </Link>
        </div>

        <p
          className="rmbr-rise text-text-tertiary"
          style={{
            ...fontStyle('bodySm'),
            ['--rmbr-stagger' as string]: '320ms',
          }}
        >
          {t('cta.note')}
        </p>
      </div>
    </section>
  );
}
